import { useRef } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import ExplorePopularSearchWrapper from 'components/pages/explore/explorepopularsearchwrapper/ExplorePopularSearchWrapper';

import { ArrowDown2, SearchNormal } from 'iconsax-react';

import classes from './ExploreFilter.module.scss';
import ExploreCareerFilter from 'components/pages/explore/explorecareerfilter/ExploreCareerFilter';
import LinkButton from '@core/components/linkbutton/LinkButton';
import { MenuItem } from '@mui/material';

const ExploreFilter = ({
	filters,
	searchKeyword,
	selectedCategories,
	selectedPrice,
	selectedStatus,
	selectedProficiency,
	selectedHighlighted,
	selectedCareerPath,
	handleCategoryClick,
	handlePriceClick,
	handlePriceSelect,
	handleProficiencySelect,
	handleStatusSelect,
	handleQueryKeywordChange,
	handleHighlightedChange,
	handleCareerPathChange,
}) => {
	const isMountedRef = useRef(false);

	const handleKeyWordChange = (e) => {
		handleQueryKeywordChange(e);
		window.scrollTo(0, 0);
	};

	const handleCareerChange = (id) => {
		window.scrollTo(0, 0);
		handleCareerPathChange(id);
	}

	const isAnyFilterActive =
		selectedCategories.length > 0 ||
		selectedPrice.length > 0 ||
		selectedProficiency.length > 0 ||
		selectedCareerPath !== null && selectedCareerPath !== undefined && selectedCareerPath !== '' ||
		selectedHighlighted.length > 0 ||
		(searchKeyword && searchKeyword.trim() !== '');

	return (
		<>
			{filters && (
				<div className={`${classes['explore-search-sidebar-wrapper']}`}>
					<span>Filters</span>
					<div className='d-flex flex-wrap gap-3'>
						<Select
							variant="standard"
							sx={{
								'&:before, &:after': {
									display: 'none',
								},
								'& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after': {
									display: 'none',
								},
								'&:hover:not(.Mui-disabled):before': {
									display: 'none',
								},
							}}
							onChange={(e) => handleStatusSelect(e.target.value)}
							className={classes['select-mui-wrapper']}
							defaultValue={selectedStatus[0] || 'all'}
						>
							<MenuItem value="all">All Status</MenuItem>
							<MenuItem value="progressing">In Progress</MenuItem>
							<MenuItem value="quiz">Quiz Awaiting</MenuItem>
							<MenuItem value="completed">Completed</MenuItem>
							<MenuItem value="ready">Not Started</MenuItem>
						</Select>
						<Select
							variant="standard"
							sx={{
								'&:before, &:after': {
									display: 'none',
								},
								'& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after': {
									display: 'none',
								},
								// optional: remove hover underline
								'&:hover:not(.Mui-disabled):before': {
									display: 'none',
								},
							}}
							onChange={(e) => handleProficiencySelect(e.target.value)}
							className={classes['select-mui-wrapper']}
							defaultValue={selectedProficiency[0] || 'all'}
						>
							<MenuItem value="all">All Proficiency</MenuItem>
							<MenuItem value="beginner">Beginner</MenuItem>
							<MenuItem value="intermediate">Intermediate</MenuItem>
							<MenuItem value="advanced">Advanced</MenuItem>
						</Select>
						<Select
							variant="standard"
							sx={{
								'&:before, &:after': {
									display: 'none',
								},
								'& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after': {
									display: 'none',
								},
								// optional: remove hover underline
								'&:hover:not(.Mui-disabled):before': {
									display: 'none',
								},
							}}
							onChange={(e) => handlePriceSelect(e.target.value)}
							className={classes['select-mui-wrapper']}
							defaultValue={selectedPrice[0] || 'all'}
						>
							<MenuItem value="all">All Price</MenuItem>
							<MenuItem value="free">Free</MenuItem>
							<MenuItem value="paid">Premium</MenuItem>
						</Select>
					</div>
				</div >
			)}
		</>
	);
};

export default ExploreFilter;
